var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.items.length)?_c('v-card',_vm._b({},'v-card',_vm.$attrs,false),[_c('v-system-bar',{attrs:{"color":"warning"}},[_vm._v("Änderungswünsche")]),_c('PersonalTable',{attrs:{"hidePerson":true,"items":_vm.items,"loading":_vm.loading},on:{"updated":_vm.fetchData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }